module.exports = __webpack_public_path__ + "static/img/content6.a1651c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/content6.png
// module id = DhIG
// module chunks = 1 3